import { render, staticRenderFns } from "./ElementMediumFactsTableColumn.vue?vue&type=template&id=41a7ba7d"
import script from "./ElementMediumFactsTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementMediumFactsTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementMediumFactsTableColumn.vue?vue&type=style&index=0&id=41a7ba7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports